import routeReplaceSelf from '@/utils/routeReplaceSelf';

const storeEmailManagement = {
    path: 'storeEmailManagement',
    name: 'storeEmailManagement',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'mailManagementV2',
        icon: 'HSIconfont hs-icon-message',
        showRealm: ['NORMAL']
    },
    children: [
        {
            path: 'storeEmailTask',
            name: 'storeEmailTask',
            component: routeReplaceSelf(() => import('@/views/storeEmailTask/index.vue')),
            meta: { code: 'mailManagementV2:storeTask' },
            children: [
                {
                    path: 'storeEmailTaskAdd',
                    name: 'storeEmailTaskAdd',
                    hidden: true,
                    component: () => import('@/views/storeEmailTask/components/Add'),
                    meta: {
                        code: 'mailManagementV2_storeTask_create',
                        activeMenu: 'storeEmailTask',
                    },
                },
                {
                    path: 'storeEmailTaskUpdate',
                    name: 'storeEmailTaskUpdate',
                    hidden: true,
                    component: () => import('@/views/storeEmailTask/components/Edit'),
                    meta: {
                        code: 'mailManagementV2_storeTask_update',
                        activeMenu: 'storeEmailTask',
                    },
                },
                {
                    path: 'storeEmailSendHistory',
                    name: 'storeEmailSendHistory',
                    hidden: true,
                    component: () => import('@/views/storeEmailTask/components/SendHistory.vue'),
                    meta: {
                        code: 'mailManagementV2_storeTask_sendHistory',
                        activeMenu: 'storeEmailTask',
                    },
                },
            ]
        },
        {
            path: 'storeSenderConfig',
            name: 'storeSenderConfig',
            component: () => import('@/views/storeSenderConfig'),
            meta: { code: 'mailManagementV2:storeSender' },
        },
    ]
};

export default storeEmailManagement;
